import { requests } from 'api';
import { MeetingType } from './types';

const apiBaseUrl = '/api/meetingtypes';

export const MeetingTypesApi = {
  getAll: (): Promise<MeetingType[]> => requests.get(apiBaseUrl),
};
